import React, {Component} from 'react';
import {observer, inject} from 'mobx-react';
import {withRouter} from 'react-router-dom';
import Dialog from 'material-ui/Dialog';
import HttpClient from 'services/HttpClient';
import {PageWrapper} from 'components/PageWrapper';
import ResourceItem from '../components/ResourceItem';

const resourceUrl = '/api/v1/resourses/';

@withRouter
@inject('resourcesStore')
@inject('alertStore')
@observer
class Resources extends Component {
  constructor(props) {
    super(props);

    this.state = {
      confirmationModalOpen: false,
      topic: null
    };
  }

  componentDidMount() {
    const {resourcesStore} = this.props;

    new HttpClient().get(`${resourceUrl}`).then(response => {
      resourcesStore.setResources(response.body.data.resourse);
    });
  }

  onResourceEdit = resource => {
    this.props.history.push(`/resources/${resource.id}/edit`);
  };

  openDeleteConfirmModal = resource => {
    const {resourcesStore} = this.props;

    resourcesStore.setResource(resource);
    this.setState({ confirmationModalOpen: true });
  }

  closeDeleteConfirmModal = () => {
    const {resourcesStore} = this.props;
    resourcesStore.initNewResource();

    this.setState({ confirmationModalOpen: false });
  }

  deleteResource = () => {
    const { resource } = this.props.resourcesStore;
    new HttpClient().delete(`${resourceUrl}${resource.id}`).then((res) => {
      if(res.status === 200) {
        this.closeDeleteConfirmModal();
        this.props.resourcesStore.deleteResource(resource.id);
        this.props.alertStore.success('You successfully deleted OSCE');
      }
    }).catch(() => {
      this.closeDeleteConfirmModal();
      this.props.alertStore.success('Something went wrong');
    });
  }

  render()  {
    const {confirmationModalOpen} = this.state;
    const {resourcesStore} = this.props;
    const {resources} = resourcesStore;
    const customContentStyle = {
      height: '100%',
      maxHeight: 'none'
    };

    return (
      <PageWrapper>
        <Dialog
          className="modal-wrapper category-handle"
          title='Are you sure you want to delete this OSCE?'
          modal={true}
          open={confirmationModalOpen}
          customContentStyle={customContentStyle}
          bodyClassName="modal-content"
          repositionOnUpdate={true}
          autoDetectWindowHeight={true}
          autoScrollBodyContent={false}>
          <div className="button-set">
            <button className="btn gray small transparanted cancel-btn" type="reset"
              onClick={this.closeDeleteConfirmModal}>No
              </button>
            <button className="btn gray small transparanted apply-btn" type="submit"
              onClick={this.deleteResource}>Yes
              </button>
          </div>
        </Dialog>
        <div className="page-container">
          <h2>OSCEs</h2>
          <div className="resources-list">
            {resources.map(resource => (
              <ResourceItem
                key={resource.id}
                resource={resource}
                openDeleteModal={this.openDeleteConfirmModal}
              />
            ))}
          </div>
        </div>
      </PageWrapper>
    );
  }
}

export default Resources;



// WEBPACK FOOTER //
// ./src/modules/resources/containers/Resources.js